module.exports = __webpack_public_path__ + "img/01.a80a3f56.jpg";